<template>
  <div>
    <div class="content-between">
      <div class="label-header">Contact Address</div>
      <div class="text-gray">
        <span v-if="limit != 0">{{ list.length }}/{{ limit }}</span>
      </div>
    </div>
    <div class="d-flex flex-column row-gap-lg">
      <template v-for="items of list">
        <div
          :key="'contact-list' + items.id"
          class="box-address"
          @click="getById(items.id)"
        >
          <div class="color-primary">{{ items.address_name }}</div>
          <div>
            <span class="text-bold text-black">
              {{ items.prefix + " " || "" }}{{ items.first_name }}
              {{ items.last_name }}
            </span>
            <span class="text-gray">
              <b-img
                :src="`https://flagcdn.com/48x36/${
                  items.telephone_country_code
                    ? items.telephone_country_code.toLowerCase()
                    : 'th'
                }.png`"
                style="width: 18px; height: 14px; margin-right: 5px"
              ></b-img>
              ({{ items.telephone_country_dial_code }})
              {{ convertTelePhone(items.telephone) }}</span
            >
          </div>
          <p class="text-gray mb-0">
            <template v-if="items.address">{{ items.address }}</template>
            <template v-if="items.building_name">
              {{ items.building_name }}</template
            >
            <template v-if="items.alley"> ซอย{{ items.alley }}</template>
            <template v-if="items.road"> ถนน{{ items.road }}</template>
            <template v-if="items.sub_district">
              แขวง{{ items.sub_district }}</template
            >
            <template v-if="items.district"> เขต{{ items.district }}</template>
            <template v-if="items.province"> {{ items.province }}</template>
            <template v-if="items.zip_code"> {{ items.zip_code }}</template>
            <template v-if="items.country"> {{ items.country }}</template>
            <br />
          </p>
          <div class="box-default" v-if="items.is_default == 1">Default</div>
        </div>
      </template>
      <div
        class="text-center box-address add"
        v-if="limit == 0 || list.length < limit"
      >
        <b-button variant="custom-primary" @click="addAddress">
          <font-awesome-icon icon="plus-square" class="pointer mr-2" />Add
          Address
        </b-button>
      </div>
    </div>
    <Sidebar
      ref="sidebar"
      header="Contact Address"
      @submit="submit"
      @hidden="clearField"
    >
      <div class="my-3">
        <b-row>
          <b-col cols="12" md="6">
            <InputSelect
              title="Name Title"
              name="Name-Title"
              :options="addressOptions.prefix.field_choices"
              v-model="form.prefix"
              valueField="name"
              textField="name"
            >
              <template v-slot:option-first>
                <b-form-select-option value="" disabled
                  >Please Select
                </b-form-select-option>
              </template>
            </InputSelect>
          </b-col>
          <b-col cols="12" md="6" v-if="checkOtherValue()">
            <InputText
              textFloat="Name Title"
              placeholder="Title"
              type="text"
              name="tax-id"
              class="mb-2"
              v-model="form.prefix_other"
            />
          </b-col>
          <div class="break-normal" v-else></div>

          <b-col cols="12" md="6">
            <InputText
              textFloat="Name"
              placeholder="Name"
              type="text"
              name="firstname"
              isRequired
              v-model="form.first_name"
              :v="$v.form.first_name"
              :isValidate="$v.form.first_name.$error"
            />
          </b-col>
          <b-col cols="12" md="6">
            <InputText
              textFloat="Surname"
              placeholder="Surname"
              type="text"
              name="surname"
              isRequired
              v-model="form.last_name"
              :v="$v.form.last_name"
              :isValidate="$v.form.last_name.$error"
            />
          </b-col>
          <b-col cols="12" md="6">
            <InputText
              textFloat="Company Name"
              placeholder="Company Name"
              type="text"
              name="company-name"
              isRequired
              v-model="form.company_name"
              :v="$v.form.company_name"
              :isValidate="$v.form.company_name.$error"
            />
          </b-col>
          <b-col cols="12" md="6">
            <InputText
              textFloat="Position"
              placeholder="Position"
              type="text"
              name="position"
              isRequired
              v-model="form.position"
              :v="$v.form.position"
              :isValidate="$v.form.position.$error"
            />
          </b-col>
          <b-col cols="12" md="6">
            <InputText
              textFloat="Email"
              placeholder="Email"
              type="email"
              name="email"
              v-model="form.email"
            />
          </b-col>
          <div class="break-normal"></div>
          <b-col cols="6">
            <InputTelephoneWithCountry
              textFloat="Primary Telephone."
              placeholder="Primary Telephone."
              :country="form.telephone_country_id"
              @set="(val) => (form.telephone_country_id = val)"
              v-model="form.telephone"
              isRequired
              :v="$v.form.telephone"
              :isValidate="$v.form.telephone.$error"
            />
          </b-col>
          <b-col cols="6">
            <InputTag
              v-model="optionalTelephone"
              :limit="parseInt(formMain.limit_secondary_telephone)"
            />
          </b-col>
          <b-col cols="12" md="6">
            <InputSelect
              title="Country"
              name="Name-Title"
              :options="[
                { value: 'ประเทศไทย', text: 'Thailand' },
                { value: 'ต่างประเทศ', text: 'Foreigner' },
              ]"
              v-model="form.country"
              valueField="value"
              textField="text"
              isRequired
              :v="$v.form.country"
              :isValidate="$v.form.country.$error"
              @onDataChange="changeCountry"
            >
              <template v-slot:option-first>
                <b-form-select-option value="" disabled
                  >Please Select
                </b-form-select-option>
              </template>
            </InputSelect>
          </b-col>
          <div class="break-normal"></div>
          <template v-if="form.country == 'ประเทศไทย' || form.country == ''">
            <b-col cols="12" md="6">
              <InputText
                textFloat="Address"
                placeholder="Address"
                type="text"
                isRequired
                name="address"
                v-model="form.address"
                :v="$v.form.address"
                :isValidate="$v.form.address.$error"
              />
            </b-col>
            <b-col cols="12" md="6">
              <InputText
                textFloat="Building / Village Name"
                placeholder="Building / Village Name"
                type="text"
                name="building"
                v-model="form.building_name"
              />
            </b-col>
            <b-col cols="12" md="6">
              <InputText
                textFloat="Alley / Soi"
                placeholder="Alley / Soi"
                type="text"
                name="alley"
                v-model="form.alley"
              />
            </b-col>

            <b-col cols="12" md="6">
              <InputText
                textFloat="Road"
                placeholder="Road"
                type="text"
                name="road"
                v-model="form.road"
              />
            </b-col>
            <b-col cols="12" md="6">
              <InputSelect
                title="Province"
                name="Province"
                :options="addressOptions.province.field_choices"
                v-model="form.province"
                valueField="name"
                textField="name"
                isRequired
                :v="$v.form.province"
                :isValidate="$v.form.province.$error"
                @onDataChange="
                  handleChange(
                    $event,
                    addressOptions.province.field_choices,
                    'district',
                    'sub_district'
                  )
                "
              >
                <!-- isRequired -->
                <template v-slot:option-first>
                  <b-form-select-option value="" disabled
                    >Please Select
                  </b-form-select-option>
                </template>
              </InputSelect>
            </b-col>
            <b-col cols="12" md="6">
              <InputSelect
                title="District"
                name="District"
                :options="[]"
                value=""
                :disabled="true"
                v-if="loading.district"
              >
                <!-- isRequired -->
                <template v-slot:option-first>
                  <b-form-select-option value="" disabled
                    >Loading...
                  </b-form-select-option>
                </template>
              </InputSelect>
              <InputSelect
                v-else
                title="District"
                name="District"
                :options="options.district.field_choices || []"
                v-model="form.district"
                valueField="name"
                textField="name"
                isRequired
                :v="$v.form.district"
                :isValidate="$v.form.district.$error"
                :disabled="!form.province"
                @onDataChange="
                  handleChange(
                    $event,
                    options.district.field_choices,
                    'subdistrict',
                    'sub_district'
                  )
                "
              >
                <!-- isRequired -->
                <template v-slot:option-first>
                  <b-form-select-option value="" disabled
                    >Please Select
                  </b-form-select-option>
                </template>
              </InputSelect>
            </b-col>
            <b-col cols="12" md="6">
              <InputSelect
                title="Subdistrict"
                name="Subdistrict"
                :options="[]"
                value=""
                :disabled="true"
                v-if="loading.subdistrict"
              >
                <!-- isRequired -->
                <template v-slot:option-first>
                  <b-form-select-option value="" disabled
                    >Loading...
                  </b-form-select-option>
                </template>
              </InputSelect>
              <InputSelect
                v-else
                title="Subdistrict"
                name="subdistrict"
                :options="options.subdistrict.field_choices || []"
                v-model="form.sub_district"
                :v="$v.form.sub_district"
                :isValidate="$v.form.sub_district.$error"
                valueField="name"
                textField="name"
                isRequired
                @onDataChange="
                  handleChange(
                    $event,
                    options.subdistrict.field_choices,
                    'zip_code'
                  )
                "
                :disabled="!form.district"
              >
                <!-- isRequired -->
                <template v-slot:option-first>
                  <b-form-select-option value="" disabled
                    >Please Select
                  </b-form-select-option>
                </template>
              </InputSelect>
            </b-col>

            <b-col cols="12" md="6">
              <InputText
                textFloat="Zip Code"
                placeholder="Zip Code"
                type="number"
                name="zip_code"
                v-model="form.zip_code"
                :v="$v.form.zip_code"
                :isValidate="$v.form.zip_code.$error"
                isRequired
                disabled
                :oninput="'javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, 5);'"
              />
            </b-col>
          </template>
          <template v-else>
            <b-col cols="12">
              <InputTextArea
                textFloat="Address"
                placeholder="Full Address."
                type="text"
                name="full-address"
                :oninput="'javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, 500);'"
                v-model="form.address"
                :v="$v.form.address"
                :isValidate="$v.form.address.$error"
                isRequired
              />
            </b-col>
          </template>
          <b-col cols="12">
            <div class="label-header">Social Media</div>
          </b-col>
          <template v-for="$social of socialList">
            <b-col cols="12" md="6" :key="$social.id">
              <InputText
                :textFloat="$social.name"
                :placeholder="$social.name"
                type="text"
                name="zip_code"
                v-model="$social.value"
                :oninput="'javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, 30);'"
              />
            </b-col>
          </template>
          <b-col cols="12">
            <div class="content-between">
              <b-form-checkbox
                id="is_default"
                name="is_default"
                :value="1"
                :unchecked-value="0"
                v-model="form.is_default"
              >
                Default
              </b-form-checkbox>
              <b-button
                variant="custom-link"
                @click="deleteAddress"
                v-if="form.id"
                >Delete</b-button
              >
            </div>
          </b-col>
        </b-row>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import Sidebar from "./Sidebar";

import {
  required,
  minLength,
  maxLength,
  requiredIf,
  email,
} from "vuelidate/lib/validators";
const telephoneFormat = (val) => {
  let validate = new RegExp(/^\d+(\-\d{1,20})?$/);

  if (validate.test(val)) return true;
  return false;
};
const TelephoneMinLength = (val, e, a) => {
  if (val.split("-")[0].length < 9 && e.telephone_country_id == 1) return false;
  return true;
  // return minLength(val);
};
export default {
  components: { Sidebar },
  props: {
    addressOptions: {
      required: true,
      type: Object,
    },
    formMain: {
      required: false,
      type: Object,
    },
    limit: { required: true, default: 0, type: Number | String },
  },
  validations() {
    return {
      form: {
        first_name: { required },
        last_name: { required },
        company_name: { required },
        position: { required },

        telephone: {
          required,
          telephoneFormat,
          TelephoneMinLength,
        },
        country: { required },
        address: { required },
        province: {
          required: requiredIf(() => {
            return this.form.country == "ประเทศไทย";
          }),
        },
        district: {
          required: requiredIf(() => {
            return this.form.country == "ประเทศไทย";
          }),
        },
        sub_district: {
          required: requiredIf(() => {
            return this.form.country == "ประเทศไทย";
          }),
        },
        zip_code: {
          required: requiredIf(() => {
            return this.form.country == "ประเทศไทย";
          }),
        },
      },
    };
  },
  data() {
    return {
      form: {
        user_guid: "",
        company_name: "",
        position: "",
        prefix: "",
        first_name: "",
        last_name: "",
        email: "",
        telephone: "",
        telephone_country_id: 1,
        optional_telephone: "",
        country: "ประเทศไทย",
        address: "",
        building_name: "",
        alley: "",
        road: "",
        sub_district: "",
        district: "",
        province: "",
        zip_code: "",
        line_id: "",
        facebook: "",
        x: "",
        is_default: 0,
      },
      list: [],

      optionalTelephone: [],
      options: { ...this.addressOptions },

      loading: {
        district: false,
        subdistrict: false,
      },
      socialList: [],
      social: [],
      errorOptional: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {},

  methods: {
    async getSocialMedia() {
      const result = await this.axios(`customer/GetSocialMediaListAll`);
      for (const social of result.data.detail) {
        social.social_media_type_id = social.id;

        if (this.social) {
          const $social = this.social.find(
            (el) => social.id == el.social_media_type_id
          );
          if ($social) {
            social.value = $social ? $social.value : "";
            social.id = $social ? $social.id : 0;
          } else {
            social.id = 0;
          }
        }
      }
      this.socialList = result.data.detail;
    },
    async getById(id) {
      this.$bus.$emit("showLoading");
      await this.$emit("getField");
      const result = await this.axios(`/customer/GetContactAddressById/${id}`);
      let data = result.data.detail.data;
      this.form = result.data.detail.data;

      this.social = result.data.detail.social;
      if (
        !this.addressOptions.prefix.field_choices.find(
          (el) => el.name == this.form.prefix
        ) &&
        this.form.prefix
      ) {
        this.form.prefix_other = data.prefix;
        this.form.prefix = this.addressOptions.prefix.field_choices.find(
          (el) => el.choice_type_id == 3
        ).name;
      }
      this.optionalTelephone = result.data.detail.data.optional_telephone
        .split(",")
        .filter((el) => el);
      await this.getSocialMedia();
      if (data.country == "ประเทศไทย") {
        if (data.province) {
          await this.handleChange(
            data.province,
            this.options.province.field_choices,
            "district",
            "subdistrict",
            false
          );
        }
        if (data.district) {
          await this.handleChange(
            data.district,
            this.options.district.field_choices,
            "subdistrict",
            "",
            false
          );
        }
      }
      this.$refs.sidebar.show();
      this.$bus.$emit("hideLoading");
    },

    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      this.$bus.$emit("showLoading");
      this.form.user_guid = this.$route.params.id;
      this.form.optional_telephone = this.optionalTelephone.join(",");

      let payload = this.socialList.map((el) => {
        return {
          id: el.id || 0,
          social_media_type_id: el.social_media_type_id,
          value: el.value,
          user_guid: this.$route.params.id,
        };
      });
      if (this.checkOtherValue()) this.form.prefix = this.form.prefix_other;
      this.form.social = payload;

      var result = null;
      if (this.form.id) {
        result = await this.axios.put(
          `/customer/UpdateContactAddress`,
          this.form
        );
      } else {
        result = await this.axios.post(
          `/customer/CreateContactAddress`,
          this.form
        );
      }

      this.$bus.$emit("hideLoading");
      if (result.data.result) {
        this.getList();
        this.successAlert();
        this.$refs.sidebar.hide();
      } else this.errorAlert(result.data.message);
    },
    async addAddress() {
      this.$bus.$emit("showLoading");
      this.form = {
        user_guid: "",
        prefix: "",
        first_name: "",
        last_name: "",
        company_name: "",
        position: "",
        email: "",
        telephone: "",
        telephone_country_id: 1,
        optional_telephone: "",
        country: "ประเทศไทย",
        address: "",
        building_name: "",
        alley: "",
        road: "",
        district: "",
        sub_district: "",
        province: "",
        zip_code: "",
        line_id: "",
        x: "",
        facebook: "",
        is_default: 0,
        social: [],
      };
      this.social = [];
      await this.$emit("getField");
      await this.getSocialMedia();
      this.$refs.sidebar.show();
      this.$bus.$emit("hideLoading");
    },
    async handleChange(val, field, $set, $set2, clear = true) {
      let payload = field.find((el) => el.name == val);
      if ($set == "zip_code") {
        this.form[$set] = payload ? payload.zip_code : "";
      } else {
        this.loading[$set] = true;
        const result = await this.axios(
          `/setting/Getsubaddress/${payload.id}/${$set == "district" ? 1 : 2}`
        );

        this.$nextTick(() => {
          this.options[$set].field_choices = result.data.detail[$set];

          if (clear) {
            this.form[$set] = "";
            this.form.zip_code = "";
            if ($set2) this.form[$set2] = "";
          }
          this.loading[$set] = false;
        });
      }
    },
    async getList() {
      const result = await this.axios(
        `/customer/GetContactAddressList/${this.$route.params.id}`
      );

      this.list = result.data.detail.result;
    },
    validateOptional(val) {
      const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);
      if (parseInt(this.formMain.limit_secondary_telephone) != 0) {
        if (
          this.optionalTelephone.length >=
          this.formMain.limit_secondary_telephone
        )
          return;
      }
      if (val.length == 10 && isNumeric(val)) {
        return val;
      }

      (this.errorOptional = true),
        setTimeout(() => {
          this.errorOptional = false;
        }, 3000);
      return;
    },
    clearField() {
      this.form = {
        user_guid: "",
        company_name: "",
        position: "",
        prefix: "",
        first_name: "",
        last_name: "",
        email: "",
        telephone: "",
        optional_telephone: "",
        telephone_country_id: 1,
        country: "",
        address: "",
        building_name: "",
        alley: "",
        road: "",
        sub_district: "",
        district: "",
        province: "",
        zip_code: "",
        line_id: "",
        facebook: "",
        x: "",
        is_default: 0,
      };
      this.optionalTelephone = [];
      this.$v.form.$reset();
    },
    async deleteAddress() {
      try {
        this.$bus.$emit("showLoading");
        const result = await this.axios.delete(
          `/customer/DeleteContactAddress/${this.form.id}`
        );
        this.$bus.$emit("hideLoading");
        if (result.data.result) {
          this.successAlert();
          this.$refs.sidebar.hide();
          this.getList();
          // this.back();
        } else {
          this.errorAlert(result.data.message);
        }
      } catch (error) {
        this.$bus.$emit("hideLoading");
        this.errorAlert(error.message);
      }
    },
    checkOtherValue() {
      if (this.addressOptions.prefix.field_choices) {
        let check = this.addressOptions.prefix.field_choices.find(
          (el) => el.name == this.form.prefix
        );

        return check && check.choice_type_id == 3;
      }
    },
    changeCountry() {
      this.form = {
        ...this.form,
        address: "",
        building_name: "",
        alley: "",
        road: "",
        district: "",
        sub_district: "",
        province: "",
        zip_code: "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.box-address {
  border-width: 1px;
  border-radius: 0.5rem;
  border-color: rgba(0, 0, 21, 0.2);
  border-style: solid;
  padding: 1rem;
  position: relative;
  cursor: pointer;
  &.add {
    border-style: dashed;
    border-color: var(--primary-color);
  }
  .box-default {
    color: green;
    border: 1px solid green;
    border-radius: 0.2rem;
    position: absolute;
    top: 10%;
    right: 10px;
    font-size: 12px;
    padding: 0 5px;
  }
}
</style>
